<template>
  <div>
    <div
      v-for="(design, idx) in designOptions"
      :key="idx"
      class="design-option-card-group"
      @click="$emit('update:selected', idx)"
    >
      <h3 class="design-option-card-title">{{ design.title }}</h3>
      <div class="plan-card design-option-card">
        <img :src="design.img" alt="" />
        <div class="plan-info">
          <p class="design-option-card-dis">{{ design.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  designOptions: Array<any>;
  selected: number | null;
}>();

const emit = defineEmits(['update:selected']);
</script>

